import { render } from "./App.vue?vue&type=template&id=6bbea0ee"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6bbea0ee&lang=css"

import exportComponent from "D:\\project\\hlqxcadm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__